import { OnboardingProps } from "../models";

interface OnboardingEvent {
    path?: string;
    currentStep?: string;
    props: OnboardingProps;
}

export async function sendOnboardingEvent(currentStep: string, props: OnboardingProps): Promise<void> {
    const event: OnboardingEvent = {
        currentStep,
        props,
    };

    // if dev, don't send
    if (__ENV__ === "development") {
        console.log("NOT SENDING ONBOARDING EVENT", event);
        return Promise.resolve();
    }

    const endpoint = "https://api.xapp.ai/cms/onboarding/events";

    // put the event in the body with the props
    await fetch(endpoint, {
        method: "PUT",
        body: JSON.stringify(event),
    })
        .then((response) => {
            if (response.status !== 200) {
                console.error("Error sending onboarding event", response);
            } else {
                console.log("Onboarding event sent successfully");
            }
        })
        .catch((error) => {
            console.error("Error sending onboarding event", error);
        });
    return Promise.resolve();
}
